// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prod-show {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 24px 32px 32px;
  background: #f8fafc;
}

.prod-show__stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  width: 100%;
}

.prod-show__top {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.prod-show__hero {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.prod-show__title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: #0f172a;
}

.prod-show__meta {
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #64748b;
}

.prod-show__card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 24px 8px;
}

.prod-show__card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
}

.prod-show__card-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.prod-show__card-title .lucide {
  color: #0ea5e9;
}

.prod-show__identifier {
  margin: 0;
  font-size: 12px;
  color: #94a3b8;
  text-align: end;
}

.prod-show__identifier span {
  color: #334155;
  font-weight: 600;
}

.prod-show__specs {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 16px 20px;
  padding-bottom: 16px;
}

.prod-show__params {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(180px, 0.8fr);
  gap: 24px;
  padding-bottom: 16px;
}

.prod-show__label {
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
}

.prod-show__value {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: #0f172a;
}

.prod-show__value.is-code {
  color: #0284c7;
}

.prod-show__value.is-qty {
  color: #0284c7;
  font-size: 20px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.prod-show__value.is-copy {
  font-weight: 500;
  color: #334155;
}

.prod-show__unit {
  margin-inline-start: 4px;
  font-size: 13px;
  font-weight: 600;
}

.prod-show__unit.is-muted {
  color: #64748b;
  font-weight: 500;
}

.prod-show__card--stocks {
  padding-bottom: 8px;
}

.prod-show__stocks {
  overflow-x: auto;
  margin: 0 -8px;
}

.prod-show__stocks table {
  width: 100%;
  border-collapse: collapse;
  text-align: start;
}

.prod-show__stocks th {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
  text-align: start;
  white-space: nowrap;
}

.prod-show__stocks td {
  padding: 14px 16px;
  border-bottom: 1px solid #eef2f6;
  color: #0f172a;
  font-size: 13px;
  vertical-align: middle;
}

.prod-show__stocks tbody tr:last-child td {
  border-bottom: 0;
}

.prod-show__stocks tbody tr:hover td {
  background: #f8fafc;
}

.prod-show__place {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #0f172a;
}

.prod-show__place .lucide {
  color: #0ea5e9;
  flex-shrink: 0;
}

.prod-show__qty-mono,
.prod-show__pending {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.prod-show__pending {
  color: #64748b;
  font-weight: 500;
}

.prod-show__updated {
  font-size: 12px;
  color: #64748b;
}

.prod-show__stocks-empty {
  padding: 8px 0 16px;
}

@media (max-width: 1100px) {
  .prod-show__specs {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .prod-show {
    padding: 20px 16px 24px;
  }

  .prod-show__specs,
  .prod-show__params {
    grid-template-columns: 1fr;
  }

  .prod-show__card-head {
    align-items: flex-start;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/ShowProduct/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":[".prod-show {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding: 24px 32px 32px;\n  background: #f8fafc;\n}\n\n.prod-show__stack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n  width: 100%;\n}\n\n.prod-show__top {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.prod-show__hero {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.prod-show__title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: #0f172a;\n}\n\n.prod-show__meta {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #64748b;\n}\n\n.prod-show__card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px 24px 8px;\n}\n\n.prod-show__card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.prod-show__card-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.prod-show__card-title .lucide {\n  color: #0ea5e9;\n}\n\n.prod-show__identifier {\n  margin: 0;\n  font-size: 12px;\n  color: #94a3b8;\n  text-align: end;\n}\n\n.prod-show__identifier span {\n  color: #334155;\n  font-weight: 600;\n}\n\n.prod-show__specs {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 16px 20px;\n  padding-bottom: 16px;\n}\n\n.prod-show__params {\n  display: grid;\n  grid-template-columns: minmax(0, 1.4fr) minmax(180px, 0.8fr);\n  gap: 24px;\n  padding-bottom: 16px;\n}\n\n.prod-show__label {\n  margin: 0 0 6px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.prod-show__value {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: #0f172a;\n}\n\n.prod-show__value.is-code {\n  color: #0284c7;\n}\n\n.prod-show__value.is-qty {\n  color: #0284c7;\n  font-size: 20px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.prod-show__value.is-copy {\n  font-weight: 500;\n  color: #334155;\n}\n\n.prod-show__unit {\n  margin-inline-start: 4px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.prod-show__unit.is-muted {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.prod-show__card--stocks {\n  padding-bottom: 8px;\n}\n\n.prod-show__stocks {\n  overflow-x: auto;\n  margin: 0 -8px;\n}\n\n.prod-show__stocks table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: start;\n}\n\n.prod-show__stocks th {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n  text-align: start;\n  white-space: nowrap;\n}\n\n.prod-show__stocks td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #eef2f6;\n  color: #0f172a;\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.prod-show__stocks tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.prod-show__stocks tbody tr:hover td {\n  background: #f8fafc;\n}\n\n.prod-show__place {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.prod-show__place .lucide {\n  color: #0ea5e9;\n  flex-shrink: 0;\n}\n\n.prod-show__qty-mono,\n.prod-show__pending {\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.prod-show__pending {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.prod-show__updated {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.prod-show__stocks-empty {\n  padding: 8px 0 16px;\n}\n\n@media (max-width: 1100px) {\n  .prod-show__specs {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 720px) {\n  .prod-show {\n    padding: 20px 16px 24px;\n  }\n\n  .prod-show__specs,\n  .prod-show__params {\n    grid-template-columns: 1fr;\n  }\n\n  .prod-show__card-head {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
